<template>
  <transition name="modal-anim">
    <div class="modal" v-if="showModal">
      <div class="modal-overlay" v-on:click="close()"></div>
      <div class="modal-close" v-on:click="close()"></div>
      <div class="modal-box">
        <div class="modal-image">
          <img :src="modalImage.image" alt="image" />          
        </div>
        <div
            class="post-image-caption-full"
            v-if="modalImage.caption"
            v-html="modalImage.caption"
          ></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Modal",
  computed: mapGetters(["showModal", "modalImage"]),
  methods: {
    ...mapActions(["setShowModal", "setModalImage"]),
    close() {
      this.setShowModal(false);
      this.setModalImage("");
    }
  }
};
</script>

<style lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  padding: 50px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  .modal-close {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 11px;
      left: -3px;
      width: 28px;
      height: 2px;
      background: $white;
      transform: rotate(45deg);
    }
    &::after {
      transform: rotate(-45deg);
    }
  }
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
  .modal-box {
    position: relative;
    max-width: 1200px;
    .modal-image {
      max-width: 100%;
      max-height: 100%;
      img {
        max-height: calc(100vh - 100px);
      }
    }
  }
}
.modal-anim-enter-active,
.modal-anim-leave-active {
  transition: opacity 0.5s;
}
.modal-anim-enter,
.modal-anim-leave-to {
  opacity: 0;
}
</style>